export const KAZAKHSTAN_REGION_ID = '40';
